import React from 'react'

export class SelectableCard extends React.Component {
    constructor(props) {
        super(props);
    }

/*
Declaration:
    <SelectableCard selected={false}
        onClick={this.companySelected.bind(this)}
        color="blue"
        iconClass="icon-pen"
        title="Manual Verification"
        optionCount={2}
    />

Props:
    bool    selected - Wether or not the option has been selected (Adds green outline if true)
    func    onClick - What event is triggered by click
    str     color - Color of icon 
    str     iconClass - Class of icon
    str     title - Title to be displayed on card in large text
    int     optionCount - How many options are available to the user to select? (For Responsive Sizing)
*/
    
    render (){
        const onClick = this.props.onClick
        const color = this.props.color
        const iconClass = this.props.iconClass
        const title = this.props.title
        const siblings = this.props.optionCount
        const siblingCount = siblings || 0

        return(
            <div class={`ps-info-box ${this.props.selected && ("selected-border")}`}
                style={{
                    fontSize: `clamp(0.8rem, 2vw / ${siblingCount + 1}, 1.25rem) `,
                    maxWidth: "100%", 
                    cursor: 'pointer'
                }}
                onClick={onClick}
            >
                <div className="selectable-card">
                    <span class={`ps-info-box-icon ${color}-icon-circle`} style={{
                        height: `clamp(35px, 10vw / ${siblingCount + 1}, 50px)`,
                        width: `clamp(35px, 10vw / ${siblingCount + 1}, 50px)`
                    }}>
                        <i class={`ps-info-box-icon-icon ${iconClass}`}></i>
                    </span>
                    <div class='ps-info-box-content' style={{ textAlign: 'center', verticalAlign: 'middle', lineHeight: '90px' }}>
                        <span class='ps-info-box-text'>
                            {title}
                        </span>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// app/helpers/Cards/SelectableCard.jsx